/** @format */
import { css } from 'styled-components';

import { mobile, smallTablet } from '@toucan/client/global/application';

import { AccountLayoutProps } from './index';

/**
 * Base styles for the account layout component
 *
 * @param {AccountLayoutProps} props The account layout properties object
 * */
const baseStyles = (props: AccountLayoutProps) => css`
    main {
        display: flex;
    }

    .site-content {
        flex-basis: 0;
        flex-grow: 1;
        padding-bottom: var(--layout-spacing-48);
    }

    .site-sidebar-nav {
        margin-right: var(--layout-spacing-48);
        padding-bottom: var(--layout-spacing-24);
    }

    .site-sidebar-nav-logout,
    .site-sidebar-nav-faq {
        margin-top: var(--layout-spacing-24);
    }

    .site-sidebar-nav-logout {
        display: block;
    }

    .site-sidebar-nav-faq {
        display: inline-block;
    }

    .site-breadcrumbs {
        margin-bottom: 1.5rem;
    }

    .site-content-title-container {
        margin-bottom: var(--layout-spacing-24);
    }

    /* Using margin collapse here if subhead not present */
    .site-content-title {
        margin-bottom: var(--layout-spacing-12);
    }

    .site-content-subhead {
        margin: 0;
    }

    ${smallTablet(css`
        main {
            display: block;
        }

        .site-sidebar-nav-buttons {
            text-align: center;
        }

        .site-content-title-container {
            margin-left: calc(var(--layout-spacing-48) * -1);
            margin-right: calc(var(--layout-spacing-48) * -1);
            padding: 0 var(--layout-spacing-24) 1.5rem;
            text-align: center;
            border-bottom: 1px solid var(--colors-border-primary);
        }

        .site-sidebar-nav-logout,
        .site-sidebar-nav-faq {
            font-size: 1.2rem;
        }

        .site-sidebar-nav-logout {
            margin-left: auto;
            margin-right: auto;
        }

        .site-sidebar-nav {
            margin: 0 calc(var(--layout-spacing-24) * -1);
        }
    `)}

    ${mobile(css`
        .site-content-title-container {
            margin-left: calc(var(--layout-spacing-24) * -1);
            margin-right: calc(var(--layout-spacing-24) * -1);
        }
    `)}
`;

/**
 * The account layout component styles
 *
 * @param {AccountLayoutProps} props The account layout properties object
 * */
export const styles = (props: AccountLayoutProps) => css`
    ${baseStyles(props)}
`;
